<template>
  <div class="ErrorMessage">
    <div class="ErrorMessage__title">
      <h2 v-if="errorType === '404'">{{ $t('errorMessage404Title') }}</h2>
      <h2 v-if="errorType === 'wrong'">{{ $t('errorMessageFailedRequestTitle') }}</h2>
      <h2 v-if="errorType === 'noResults'">{{ $t('errorMessageNoResultsTitle') }}</h2>
    </div>
    <div class="ErrorMessage__message">
      <p v-if="errorType === '404'">
        {{ $t('errorMessage404Message') }}
      </p>
      <p v-if="errorType === 'wrong'">
        {{ $t('errorMessageFailedRequestMessage') }}
      </p>
      <p v-if="errorType === 'noResults'">
        {{ $t('errorMessageNoResultsMessage') }}
      </p>
    </div>
    <div
      v-if="errorType === '404'"
      class="ErrorMessage__link"
    >
      <a href="./">
        <el-button type="primary">
          {{ $t('errorMessage404BackHomeButton') }}
        </el-button>
      </a>
    </div>
    <div
      v-if="errorType === 'wrong'"
      class="ErrorMessage__link"
    >
      <el-button
        type="primary"
        @click="refreshPage"
      >
        {{ $t('errorMessageFailedRequestRefreshPageButton') }}
      </el-button>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { Button } from 'element-ui';

Vue.use(Button);

export default {
  name: 'ErrorMessage',
  props: {
    errorType: {
      type: String,
      default: 'wrong',
      validator: value =>
        // The value must match one of these strings
        ['404', 'wrong', 'noResults'].indexOf(value) !== -1
      ,
    },
  },
  methods: {
    refreshPage() {
      this.$router.go();
    },
  },
};
</script>

<style scoped lang="scss">
.ErrorMessage {
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
}
.ErrorMessage__message {
  @include roboto300;
}
</style>
